import type { AdminProductFilter, AdminProductSort } from "@listou/shared/schemas/admin";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { ProductControls, ProductsTable } from "../components/admin/products";
import { Box, Pending } from "../components/admin/retro";
import { adminProductsQuery } from "../lib/queries";

export const Route = createFileRoute("/_authed/admin/produits")({
  component: ProductsPage,
});

function ProductsPage() {
  const [sort, setSort] = useState<AdminProductSort>("recent");
  const [filter, setFilter] = useState<AdminProductFilter>("all");
  const products = useQuery(adminProductsQuery({ sort, filter }));
  return (
    <Box
      title="produits"
      right={<ProductControls sort={sort} filter={filter} onSort={setSort} onFilter={setFilter} />}
    >
      {products.data ? (
        <div className={products.isPlaceholderData ? "opacity-60" : undefined}>
          <ProductsTable products={products.data.products} />
        </div>
      ) : (
        <Pending query={products} />
      )}
    </Box>
  );
}
